import { render, staticRenderFns } from "./team-goods-list.vue?vue&type=template&id=994f8882&scoped=true&"
import script from "./team-goods-list.vue?vue&type=script&lang=js&"
export * from "./team-goods-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994f8882",
  null
  
)

export default component.exports